import { useMutation, useQueryClient } from "react-query";
import { useState } from "react";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { useSnackbar } from "src/utils/useSnackbar.tsx";
import { getAllDocumentsKey } from "src/api/client-api/documentation/useGetAllDocuments.ts";

export const useDeleteMediaContent = () => {
    const [deleting, setDeleting] = useState(false);
    const queryClient = useQueryClient();

    const snackbar = useSnackbar();

    const query = useMutation({
        mutationKey: ["deleteMediaContent"],
        mutationFn: async ({ id }: { id: string }) => {
            const url = `/api/cms/contents/medias/${id}`;
            setDeleting(true);

            return await loggedInApiCall.delete(url);
        },
        onError: () => {
            setDeleting(false);
            snackbar.forceClose();
            snackbar.setSnackbarProps({
                type: "error",
                message: "Error deleting document",
            });
        },
        onSuccess: () => {
            setDeleting(false);
            queryClient.invalidateQueries([getAllDocumentsKey]);
        },
    });

    return {
        query,
        deleting,
    };
};
